import 'mp-react-components/dist/mp-react-components.min.css'
import { AppRoutes } from './router'
import { HashRouter as Router } from 'react-router-dom'
import { NotificationProvider } from './contexts/NotificationContext'

const App = () => {
  return (
    <Router>
      <NotificationProvider>
        <AppRoutes />
      </NotificationProvider>
    </Router>
  )
}

export default App
